export const APP_HEADER = "REACH";
export const HOMEPAGE_WELCOME_MESSAGE = "WELCOME TO REACH";
export const HOMEPAGE_LATEST_FEED_MESSAGE = "LATEST FEED";
export const FORBIDDEN_RESPONSE_STATUS = 403;

// User Role
export const GTL_GLOBAL_ADMIN = "GTL_Global Admins";
export const GTL_COUNTRY_ADMIN = "GTL_CA_";
export const GTL_BASIC_USER = "GTL_BU_";
export const GTL_COUNTRY_APPROVER = "GTL_CAPP_";
// END - User Role

export const IVR_FLOW_CONTAINER_NAME = "ivr-flow-resources";
export const BATCH_MESSAGE_CONTAINER_NAME = "batch-messages";

export const READ_ONLY_VARIABLE_NAME = "WhatsappFlow";
